/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.375 16.5 6.75 18l.461 1.8443.063.2516c.1148.4592-.2325.9041-.7059.9041a.7276.7276 0 0 1-.7059-.5511l-.0632-.2529-.8358-3.3431L4.875 16.5H4.5C2.0147 16.5 0 14.4853 0 12s2.0147-4.5 4.5-4.5h5.0486a7.4976 7.4976 0 0 1 3.4806-3.5638L19.5.7407 21 0v7.756c1.7478.6178 3 2.2847 3 4.244 0 1.9593-1.2522 3.6262-3 4.2439V24l-1.5-.7407-6.4708-3.1955A7.4978 7.4978 0 0 1 9.5486 16.5H6.375Zm7.3183-11.2188L19.5 2.4137V8.8168l1.0001.3535C21.6673 9.583 22.5 10.6961 22.5 12c0 1.3039-.8327 2.4171-1.9999 2.8297l-1.0001.3535V21.5863l-5.8067-2.8675a5.9972 5.9972 0 0 1-2.7845-2.8512L10.5054 15H10.5V9h.0054l.4034-.8676a5.9971 5.9971 0 0 1 2.7845-2.8512ZM9 9H4.5c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3H9V9Z"
    clipRule="evenodd"
  />,
  'LoudSpeaker'
);
